export const SET_USER_ID = "SET_USER_ID";
export const SET_TOKEN = "SET_TOKEN";
export const SET_FORCE_CHANGE_PASSWORD = "SET_FORCE_CHANGE_PASSWORD";
export const SET_INIT_HOME_LIST = 'SET_INIT_HOME_LIST';
export const SET_CHEF = "SET_CHEF";
export const BECOME_CHEF = "BECOME_CHEF";
export const FEATURED_CHEFS = "FEATURED_CHEFS";
export const FEATURED_DISHES = "FEATURED_DISHES";
export const FETCH_POSTS = "FETCH_POSTS";
export const FETCH_POSTS_SUCCESS = "FETCH_POSTS_SUCCESS";
export const FETCH_POSTS_FAILD = "FETCH_POSTS_FAILD";
export const GET_CHEF = "GET_CHEF";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const CHEF_TRANSACTIONS = "CHEF_TRANSACTIONS";
export const TRANSACTION_FILTERS = "TRANSACTION_FILTERS";

export const ADD_TO_CART = "ADD_TO_CART";
export const CREATE_IN_PROGRESS_BOOKING = "CREATE_IN_PROGRESS_BOOKING";
export const UPDATE_IN_PROGRESS_BOOKING = "UPDATE_IN_PROGRESS_BOOKING";
export const CREATE_BOOKING = "CREATE_BOOKING";
export const SELECT_CHEF_FOR_BOOKING = "SELECT_CHEF_FOR_BOOKING";
export const SELECTED_BOOKING_DATE = 'SELECTED_BOOKING_DATE';
export const SELECTED_BOOKING_SLOT = 'SELECTED_BOOKING_SLOT';
export const SET_EX_BOOKING = 'SET_EX_BOOKING';
export const SET_VIEW_AS_DINER = 'SET_VIEW_AS_DINER';
export const SHOW_BECOME_CHEF_MSG = 'SHOW_BECOME_CHEF_MSG';

export const FETCH_POSTS_DRAFTED = "FETCH_POSTS_DRAFTED";
export const FETCH_POSTS_SUCCESS_DRAFTED = "FETCH_POSTS_SUCCESS_DRAFTED";
export const FETCH_FEATURED_POSTS = "FETCH_FEATURED_POSTS";
export const FETCH_POSTS_FAILD_DRAFTED = "FETCH_POSTS_FAILD_DRAFTED";
export const UPDATE_STEP = "UPDATE_STEP";

export const SET_DINER_DETAILS = "SET_DINER_DETAILS";
export const SET_CHEF_DETAILS = "SET_CHEF_DETAILS";
export const SET_DINER_PAYMENTINFO = "SET_DINER_PAYMENTINFO";

export const SET_CURRENT_BOOKING = "SET_CURRENT_BOOKING";
export const SET_CHEF_AVAILABILITY = "SET_CHEF_AVAILABILITY";
export const LOADING_CHEF = "LOADING_CHEF";
export const LOADING_CHEF_SUCCESS = "LOADING_CHEF_SUCCESS";

export const SET_CHEF_FILTERS = "SET_CHEF_FILTERS";
export const CLEAR_CHEF_FILTERS = "CLEAR_CHEF_FILTERS";
export const SET_CHEF_SEARCH_BY_NAME = 'SET_CHEF_SEARCH_BY_NAME';
export const SET_DISH_SEARCH_BY_NAME = 'SET_DISH_SEARCH_BY_NAME';
export const SET_POST_SEARCH_BY_NAME = 'SET_POST_SEARCH_BY_NAME';

export const SET_BOOKINGS_NAV_STEP = 'SET_BOOKINGS_NAV_STEP';
export const SET_RETURN_URL = 'SET_RETURN_URL';

export const SET_DISH_FILTERS = "SET_DISH_FILTERS";
export const CLEAR_DISH_FILTERS = "CLEAR_DISH_FILTERS";

export const SET_SAVED_CHEFS = "SET_SAVED_CHEFS";
export const SET_SAVED_DISHES = "SET_SAVED_DISHES";
export const SET_SAVED_POSTS = "SET_SAVED_POSTS";
export const SET_USER_REVIEW_TAGS = "SET_USER_REVIEW_TAGS";
export const SET_CHEF_REVIEW_TAGS = "SET_CHEF_REVIEW_TAGS";

export const SOCKET_LOGIN = "SOCKET_LOGIN";
export const SOCKET_LOGIN_SUCCESS = "SOCKET_LOGIN_SUCCESS";
export const SET_CHAT_LIST = "SET_CHAT_LIST";

export const SET_BOOKING_COMPLETED_STEP = 'SET_BOOKING_COMPLETED_STEP';
export const SET_IS_RECURRING_BOOKING = 'SET_IS_RECURRING_BOOKING';
export const SET_CUSTOM_PRICE_RANGE = 'SET_CUSTOM_PRICE_RANGE';
export const SET_CUSTOM_BOOKING_ADDRESS = 'SET_CUSTOM_BOOKING_ADDRESS';
export const SET_SELECTED_CHEF_AND_SLOT = 'SET_SELECTED_CHEF_AND_SLOT';
